import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { BaseForm } from 'projects/admin/src/app/classes/base-form';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { FormHelper } from 'projects/admin/src/app/shared/form-helper';

@Component({
  selector: 'app-data-scope-new',
  templateUrl: './data-scope-new.component.html',
  styleUrls: ['./data-scope-new.component.scss']
})
export class DataScopeNewComponent extends BaseForm implements OnInit {

  public dimensionOptions: Array<{ key: string, label: string }> = [];

  public form = this.fb.group({
    name: new UntypedFormControl('', [Validators.required]),
    dimensions: new UntypedFormControl([], [Validators.required]),
    title_de: new UntypedFormControl('', [Validators.required]),
    title_en: new UntypedFormControl('', [Validators.required]),
    description: new UntypedFormControl(''),
    active: new UntypedFormControl(true, [Validators.required]),
  });

  constructor(
    private fb: UntypedFormBuilder,
    private ui: UiService,
    private api: ApiService,
    private router: Router,
    private auth: AuthStateService,
    private transloco: TranslocoService
  ) {
    super();
  }

  ngOnInit(): void {
    this.auth.checkRightOrRedirect('admin.datascope.create');
    this.refreshDimensionOptions();
    this.ui.setFormFocus();
  }

  onCancel(): void {
    this.router.navigate(['/data-scopes']);
  }

  onSubmit(): void {
    this.ui.hideMessage();
    if (this.form.valid === true) {
      this.submitting = true;
      const payload: any = {
        id: null,
        name: this.form.value.name,
        dimensions: this.getSelectedDimensionKeys(),
        title_de: this.form.value.title_de,
        title_en: this.form.value.title_en,
        description: this.form.value.description,
        active: this.form.value.active,
      };
      this.api.saveModel('data-scopes', null, payload).subscribe({
        next: (result: any) => {
          this.router.navigate(['/data-scopes', result.data.id]);
          this.ui.toastSuccess(this.transloco.translate('common.messages.saved', { value: this.form.value.name }), this.transloco.translate('common.saved'));
        },
        error: (error: any) => {
          this.ui.showMessage('error', this.transloco.translate(error.message), this.transloco.translate('common.error'));
          FormHelper.setBackendErrors(this.form, error.fielderrors);
        }
      }).add(() => {
        this.submitting = false;
      });
    } else {
      this.ui.showMessage('error', this.transloco.translate('common.error_on_form_please_correct'), this.transloco.translate('common.error'));
      FormHelper.markFormAsDirty(this.form);
    }
  }

  showEmptyDimensionWarning(): boolean {
    return this.getSelectedDimensionKeys().length > 0;
  }

  private refreshDimensionOptions(): void {
    this.dimensionOptions = [
      { key: 'template', label: this.transloco.translate('common.labels.procedures') },
      { key: 'businessunit', label: this.transloco.translate('common.labels.businessunits') },
    ];
  }

  private getSelectedDimensionKeys(): Array<string> {
    const selected = this.form.get('dimensions').value;
    if (!Array.isArray(selected)) {
      return [];
    }
    return selected.map((option: { key: string }) => option.key);
  }

}
